import { render, staticRenderFns } from "./MovimentacaoLista.vue?vue&type=template&id=766393da&scoped=true"
import script from "./MovimentacaoLista.vue?vue&type=script&lang=js"
export * from "./MovimentacaoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766393da",
  null
  
)

export default component.exports